export default __webpack_public_path__ + "0c4087f559f9e2fd65728a4b38c2b141.jpg";